'use client';

import { useEffect, useState } from 'react';

import { MILLION_CATCHES } from '@config/constants';

import { DownloadAppContent } from './components/DownloadAppContent';
import { getRandomInteger } from '@lib/numbers/getRandomInteger';

export const DownloadAppVerticalCTA = () => {
  const [randomAddCopyVarient, setRandomAddCopyVarient] = useState(0);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- FIB-49117
    setRandomAddCopyVarient(getRandomInteger(1, 2));
  }, []);

  switch (randomAddCopyVarient) {
    case 1:
      return (
        <DownloadAppContent
          headingText="Download the Fishbrain app"
          subHeadingText={`Discover ${MILLION_CATCHES} million fishing spots, top baits, and more`}
        />
      );
    case 2:
      return <DownloadAppContent />;
    default:
      return <DownloadAppContent isLoading />;
  }
};
